import React, { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import { Alert } from 'reactstrap';
import renderInputField from '../formFields/Input';
import { LOGIN_PATH } from '../../utils/constants';
import { validate } from '../../utils/form';

class ResetPasswordForm extends PureComponent {
  render() {
    const {
      handleSubmit,
      valid,
      submitting,
      hasError,
      success,
      email
    } = this.props;

    if (success) {
      return (
        <div className="confirmation-title">
          A confirmation email was sent to{' '}
          {email && <span className="link">{email}</span>}
        </div>
      );
    }
    return (
      <div className="auth-form login-form">
        <div className="error-wrapper">
          {hasError && (
            <Alert color="danger">Email address not found. Try again?</Alert>
          )}
        </div>
        <div className="form-title">
          Please enter the email address you use to log in
        </div>
        <form className="form" onSubmit={handleSubmit}>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Field
                name="email"
                component={renderInputField}
                type="text"
                placeholder="Email"
              />
            </div>
          </div>
          <div className="block-centered">
            <button
              className="btn btn-primary account__btn account__btn--small"
              disabled={!valid || submitting}
              onClick={handleSubmit}
            >
              Reset password
            </button>
          </div>
          <div className="full-width auth-link">
            Back to <Link to={LOGIN_PATH}>login page</Link>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'ResetPasswordForm',
  validate
})(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/components/resetPassword/ResetPasswordForm.js